import React, { useEffect, useState } from 'react';
import api from '../axios'; // Import the Axios instance

const SnippetList = ({ onSnippetSelect }) => {
  const [snippets, setSnippets] = useState([]); // State to store snippets
  const [error, setError] = useState(null); // State to store error messages
  const [loading, setLoading] = useState(true); // State to track loading
  const [includeArchived, setIncludeArchived] = useState(false);
  const [searchQuery, setSearchQuery] = useState(''); // Search query state

  useEffect(() => {
    const fetchSnippets = async () => {
      setLoading(true); // Start loading
      try {
        const response = await api.get('/api/snippets', {
          params: { include_archived: includeArchived }, // Send the archived filter
        });
        console.log('API Response:', response.data);
        setSnippets(response.data.snippets); // Update state
        setError(null); // Clear any previous errors
      } catch (err) {
        console.error('Error fetching snippets:', err);

        // Only display errors if the request was not retried
        if (!err.config || !err.config._retry) {
          setError('Failed to fetch snippets. Please try again.');
        }
      } finally {
        setLoading(false); // End loading
      }
    };

    fetchSnippets(); // Call the function
  }, [includeArchived]); // Dependency array includes includeArchived

  // Filter snippets by search query
  //const lowerCaseQuery = searchQuery.toLowerCase();
  //const filteredSnippets = snippets.filter((snippet) =>
  //  snippet.title.toLowerCase().includes(lowerCaseQuery) ||
  //  snippet.language.toLowerCase().includes(lowerCaseQuery) ||
  //  snippet.content.toLowerCase().includes(lowerCaseQuery) ||
  //  snippet.tags.some((tag) => tag.toLowerCase().includes(lowerCaseQuery))
  //);

  const searchTerms = searchQuery.toLowerCase().split(/\s+/); // Split on spaces

  const filteredSnippets = snippets.filter((snippet) =>
    searchTerms.every((term) =>
      snippet.title.toLowerCase().includes(term) ||
      snippet.language.toLowerCase().includes(term) ||
      snippet.content.toLowerCase().includes(term) ||
      snippet.tags.some((tag) => tag.toLowerCase().includes(term))
    )
  );




  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%', // Take full height of parent
      }}
    >
      {/* Sticky Top Row */}
      <div className="header"
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 1000,
          background: '#E5E7E9',
          borderBottom: '1px solid #ddd',
          padding: '10px',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        }}
      >
        <button onClick={() => setIncludeArchived(!includeArchived)}>
          {includeArchived ? 'Hide Archived' : 'Show Archived'}
        </button>
        <input
          type="text"
          placeholder="Search snippets..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          style={{
            marginLeft: '10px',
            padding: '5px',
            width: '70%',
            border: '1px solid #ccc',
            borderRadius: '4px',
          }}
        />
      </div>

      {/* Scrollable List */}
      <div
        style={{
          overflowY: 'auto', // Make this pane scrollable
          flexGrow: 1, // Allow it to fill remaining vertical space
          padding: '10px',
        }}
      >
        {loading ? (
          <p>Loading snippets...</p>
        ) : error ? (
          <p style={{ color: 'red' }}>{error}</p>
        ) : (
          <ul style={{ listStyleType: 'none', padding: 0 }}>
            {filteredSnippets.map((snippet) => (
              <li
                key={snippet.id}
                onClick={() => onSnippetSelect(snippet.id)}
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  borderBottom: '1px solid #5D6D7E',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                {/* Favorite Indicator */}
                {snippet.favorite && (
                  <span
                    style={{
                      color: '#F1C40F',
                      marginRight: '1px',
                      fontSize: '18px',
                      lineHeight: '1',
                    }}
                  >
                    ★
                  </span>
                )}
                <div>
                  <strong>{snippet.title}</strong> - {snippet.language}
                  <br />
                  Tags: {snippet.tags?.join(', ') || 'No tags'}
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default SnippetList;

